import Api from 'utils/api'

export const fetchCandidates = ({ id }: { id: number | string }) => Api.get(['candidates', id])
